import i18n from 'services/base/i18n';

export default {
  // Save button for editing user information
  save: () => i18n.pgettext('Pages|Edit Settings', 'SAVE'),
  // Label for the user's email address
  emailAddress: () => i18n.pgettext('Pages|Edit Settings', 'Email Address'),
  // Label for the user's country
  country: () => i18n.pgettext('Pages|Edit Settings', 'Country'),
  // Label for the user's mobile number
  mobileNumber: () => i18n.pgettext('Pages|Edit Settings', 'Mobile Number'),
  mobilePrefix: (prefix: string) => prefix,
  // Link to the change password page
  changePassword: () => i18n.pgettext('Pages|Edit Settings', 'CHANGE PASSWORD'),
  // If the user changes his email address, this shows up telling the user he needs to verify his new email address.
  verifyYourEmailAdress: () => i18n.pgettext('Pages|Edit Settings', 'You have an unverified email address. Please verify'),

  // Link to the delete account page
  deleteAccount: () => i18n.pgettext('Pages|Edit Settings', 'DELETE ACCOUNT'),
};
